import { getPasswordStrengthInfo } from '@/utils/passwordHelpers'

interface PasswordStrengthIndicatorProps {
  password: string
  strength: number
  className?: string
}

export function PasswordStrengthIndicator({
  password,
  strength,
  className = ''
}: PasswordStrengthIndicatorProps) {
  if (!password) return null

  const strengthInfo = getPasswordStrengthInfo(strength)

  return (
    <div className={`mt-2 ${className}`}>
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs text-gray-600 font-hebrew">חוזק סיסמה:</span>
        <span className={`text-xs font-medium font-hebrew ${strengthInfo.textColor}`}>
          {strengthInfo.text}
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className={`h-2 rounded-full transition-all duration-300 ${strengthInfo.color}`}
          style={{ width: strengthInfo.width }}
          role="progressbar"
          aria-valuenow={strength}
          aria-valuemin={0}
          aria-valuemax={4}
          aria-label={`חוזק סיסמה: ${strengthInfo.text}`}
        />
      </div>

      <div className="mt-1 text-xs text-gray-500 font-hebrew space-y-1">
        <p className="font-medium text-gray-600">דרישות סיסמה:</p>
        <ul className="list-disc list-inside space-y-0.5 text-gray-500">
          <li>
            <strong>אורך:</strong> לפחות 6 תווים (מומלץ 8+)
          </li>
          <li>
            <strong>אותיות:</strong> עברית (א-ת) או אנגלית (A-Z, a-z)
          </li>
          <li>
            <strong>מספרים:</strong> 0-9
          </li>
          <li>
            <strong>סימנים מיוחדים:</strong> ! @ # $ % ^ & * ( ) - = + [ ] ועוד
          </li>
        </ul>

        <div className="mt-2 space-y-1">
          <p className="text-green-600 text-xs">
            ✓ <strong>דוגמאות טובות:</strong>
          </p>
          <p className="text-xs text-gray-600">
            • MyPassword123! • הסיסמה456# • School2024@
          </p>
        </div>
      </div>
    </div>
  )
}
